(function () {
  function formatModelLines(models) {
    return String(models)
      .split(/\s*(?:,|·)\s*/)
      .map((item) => item.trim())
      .filter(Boolean)
      .map(escapeHtml)
      .join('<br>');
  }

  function cellModels(root, label) {
    const text = label.toLowerCase().replace(/\s+/g, ' ');
    const connector = root.dataset.compat22mmConnector || '';
    const ultra = root.dataset.compat22mmUltra || '';
    const isUltraRow = text.includes('ultra');
    const isConnectorRow = !isUltraRow && (text.includes('connector') || text.includes('موصل') || text.includes('sam 8'));

    if (text.includes('fit') && root.dataset.compat20mmFit) {
      return root.dataset.compat20mmFit;
    }

    if (isUltraRow && ultra) {
      return ultra;
    }

    if (isConnectorRow && connector) {
      return connector;
    }

    if (/(^|[^0-9])22\s*(mm|مم)/.test(text) && !isConnectorRow && !isUltraRow && root.dataset.compat22mm) {
      return root.dataset.compat22mm;
    }

    if (/(^|[^0-9])20\s*(mm|مم)/.test(text) && !text.includes('fit') && root.dataset.compat20mm) {
      return root.dataset.compat20mm;
    }

    return '';
  }

  const BRAND_ALIASES = {
    samsung: ['samsung', 'سامسونج'],
    huawei: ['huawei', 'هواوي', 'هواوى'],
    garmin: ['garmin', 'جارمين', 'غارمين'],
    apple: ['apple', 'أبل', 'آبل', 'ابل']
  };

  function brandNeedles(brand) {
    const key = String(brand || '').trim().toLowerCase();
    return BRAND_ALIASES[key] || [key];
  }

  function findBrandTable(root, brand) {
    if (!brand) {
      return null;
    }

    const needles = brandNeedles(brand);
    const headings = Array.from(root.querySelectorAll('.juzoori-size-guide__heading, h2, h3, h4'));
    const heading = headings.find((node) => {
      const text = (node.textContent || '').toLowerCase();
      return needles.some((needle) => text.includes(String(needle).toLowerCase()));
    });

    if (heading) {
      let node = heading;
      while (node && node !== root) {
        let sibling = node.nextElementSibling;
        while (sibling) {
          if (sibling.matches('table')) {
            return sibling;
          }
          const nested = sibling.querySelector('table');
          if (nested) {
            return nested;
          }
          if (sibling.matches('.juzoori-size-guide__heading, h2, h3, h4')) {
            break;
          }
          sibling = sibling.nextElementSibling;
        }
        node = node.parentElement;
      }
    }

    return Array.from(root.querySelectorAll('table')).find((table) =>
      Array.from(table.querySelectorAll('td')).some((cell) => /^\s*20\s*mm/i.test(cell.textContent || ''))
    ) || null;
  }

  function fillRoot(root) {
    if (!root || !(root.dataset.watchBrand || '').trim()) {
      return;
    }

    const brand = root.dataset.watchBrand.trim().toLowerCase();
    if (brand === 'juzoori') {
      return;
    }

    const table = findBrandTable(root, brand);
    if (!table) {
      return;
    }

    const rtl = document.documentElement.getAttribute('dir') === 'rtl';
    Array.from(table.rows).forEach((row) => {
      const cells = row.cells;
      if (!cells || cells.length < 2) {
        return;
      }

      const models = cellModels(root, cells[0].textContent || '');
      if (!models) {
        return;
      }

      const valueCell = cells[cells.length - 1];
      valueCell.classList.add('juzoori-compat-models');
      valueCell.innerHTML = rtl
        ? '<bdi dir="ltr" class="juzoori-size-guide__models">' + formatModelLines(models) + '</bdi>'
        : '<span dir="ltr" class="juzoori-size-guide__models">' + formatModelLines(models) + '</span>';
    });
  }

  function enhance() {
    document.querySelectorAll('juzoori-size-chart').forEach(fillRoot);
  }

  class JuzooriSizeChart extends HTMLElement {
    connectedCallback() {
      fillRoot(this);
    }
  }

  if (!customElements.get('juzoori-size-chart')) {
    customElements.define('juzoori-size-chart', JuzooriSizeChart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('.size-chart-link, [aria-controls*="size-chart"]')) {
      window.setTimeout(enhance, 50);
      window.setTimeout(enhance, 300);
    }
  });

  document.addEventListener('dialog:after-show', enhance);
  document.addEventListener('shopify:section:load', enhance);
})();
